import { randomInt } from './math.js';
export function chunk(str, size) {
    const R = [];
    for (let i = 0; i < str.length; i += size) {
        R.push(str.slice(i, i + size));
    }
    return R;
}
export function exclude(item, list) {
    return list.filter((i) => i !== item);
}
export function randomElement(list) {
    return list[randomInt(list.length)];
}
//# sourceMappingURL=arrays.js.map